import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminListingsApi as n } from "@maat/api-main";
//#region src/listings/admin/useAdminListingModerationQuery.ts
var r = (r = {}) => t({
	queryKey: e.listingModeration(r),
	queryFn: () => n.listModeration(r)
});
//#endregion
export { r as useAdminListingModerationQuery };
